document.documentElement.classList.add('js-ready');

(function () {
  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.nodeValue = node.nodeValue
        .replace(/\$1,305/g, '$1,355')
        .replace(/\b1305\.00\b/g, '1355.00')
        .replace(/\b1305\b/g, '1355');
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT'].includes(node.tagName)) return;
    node.childNodes.forEach(replaceText);
  }

  function fixModulePrice() {
    document.querySelectorAll('tr, article').forEach(function (row) {
      if (!/Start Platform/i.test(row.textContent || '')) return;
      row.childNodes.forEach(replaceText);
      row.innerHTML = row.innerHTML.replace(/\$75/g, '$125');
      if (!row.querySelector('.module-code') && row.tagName === 'TR') {
        var firstCell = row.querySelector('td');
        if (firstCell) {
          firstCell.innerHTML = '<strong>Start Platform</strong><span class="module-code">Code: 0002</span>';
        }
      }
    });
  }

  function addColorSection() {
    if (document.querySelector('.color-options')) return;
    var target = document.querySelector('.module-section, #specs, .intro');
    if (!target) return;

    var section = document.createElement('section');
    section.className = 'color-options product-color-options';
    section.id = 'colors';
    section.innerHTML = [
      '<div class="section-heading">',
      '<p class="eyebrow">Color customization</p>',
      '<h2>Built in your colors.</h2>',
      '<p>Choose from 7 standard powder-coat colors for your club, shop, or event setup. Color selection does not add product cost; slight color difference may happen between screen preview and final production.</p>',
      '</div>',
      '<div class="color-showcase">',
      colorCard('rugpeak-color-orange.png', 'Rugpeak Orange', '#e8501e'),
      colorCard('rugpeak-color-moss-green.png', 'Moss Green', '#5a7247'),
      colorCard('rugpeak-color-signal-yellow.png', 'Signal Yellow', '#f2b705'),
      colorCard('rugpeak-color-sky-blue.png', 'Sky Blue', '#5b9bd5'),
      '</div>',
      '<div class="color-palette" aria-label="Available color choices">',
      '<span class="swatch-orange"><strong>Rugpeak Orange</strong><small>RAL 2009</small></span>',
      '<span class="swatch-moss"><strong>Moss Green</strong><small>RAL 6011</small></span>',
      '<span class="swatch-yellow"><strong>Signal Yellow</strong><small>RAL 1003</small></span>',
      '<span class="swatch-blue"><strong>Sky Blue</strong><small>RAL 5012</small></span>',
      '<span class="swatch-red"><strong>Clay Red</strong><small>RAL 3016</small></span>',
      '<span class="swatch-gray"><strong>Slate Gray</strong><small>RAL 7012</small></span>',
      '<span class="swatch-black"><strong>Graphite Black</strong><small>RAL 9011</small></span>',
      '</div>',
      '<p class="color-note">Custom RAL colors can also be discussed before order preparation. Final color is confirmed with your quote details.</p>'
    ].join('');
    target.parentNode.insertBefore(section, target);
  }

  function colorCard(file, name, swatch) {
    var base = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var src = base + 'cdn/shop/t/13/assets/' + file;
    return '<article class="color-card"><img src="' + src + '" width="1800" height="1800" alt="Rugpeak obstacle ' + name + ' color reference"><span>' + name + '<i style="background:' + swatch + '"></i></span></article>';
  }

  function injectColorStyles() {
    if (document.getElementById('rugpeak-live-fix-style')) return;
    var style = document.createElement('style');
    style.id = 'rugpeak-live-fix-style';
    style.textContent = [
      '.module-code{display:block;margin:4px 0 8px;color:#7a5737;font-size:12px;font-weight:700;text-transform:uppercase;}',
      '.color-options{padding:80px 5vw;background:#f7f4ee;border-top:1px solid #c9c0ae;border-bottom:1px solid #c9c0ae;}',
      '.color-showcase{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px;}',
      '.color-card{overflow:hidden;padding:12px;background:#fff;border:1.5px solid #d8c8ad;border-radius:16px;box-shadow:5px 5px 0 rgba(73,55,30,.1);}',
      '.color-card img{display:block;width:100%;aspect-ratio:1/1;object-fit:contain;border-radius:10px;background:#f4efe5;}',
      '.color-card span{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:12px;font-weight:900;}',
      '.color-card i{display:block;width:22px;height:22px;border:2px solid rgba(22,32,38,.22);border-radius:50%;}',
      '.color-palette{display:flex;flex-wrap:wrap;gap:12px;margin-top:22px;}',
      '.color-palette span{display:inline-flex;align-items:center;gap:10px;min-height:48px;padding:7px 14px 7px 8px;background:#fff;border:1.5px solid #d8c8ad;border-radius:999px;font-size:13px;font-weight:850;}',
      '.color-palette span:before{content:"";flex:0 0 auto;width:32px;height:32px;border:2px solid rgba(22,32,38,.18);border-radius:50%;}',
      '.color-palette strong,.color-palette small{display:block;}.color-palette small{color:#8a9094;font-size:11px;font-weight:800;line-height:1.1;}',
      '.swatch-orange:before{background:#e8501e}.swatch-moss:before{background:#5a7247}.swatch-yellow:before{background:#f2b705}.swatch-blue:before{background:#5b9bd5}.swatch-red:before{background:#b5402f}.swatch-gray:before{background:#5e6468}.swatch-black:before{background:#26282a}',
      '.color-note{margin:18px 0 0;color:#5d665f;font-size:14px;font-weight:760;}',
      '@media(max-width:1060px){.color-showcase{grid-template-columns:repeat(2,minmax(0,1fr));}}',
      '@media(max-width:760px){.color-options{padding:54px 5vw;}.color-showcase{grid-template-columns:1fr;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function fixContactChannels() {
    document.querySelectorAll('.contact-channels .channel-buttons').forEach(function (buttons) {
      var email = buttons.querySelector('.channel-button.email');
      if (email) {
        email.href = 'mailto:donglin9823@gmail.com?subject=Rugpeak%20RC%20Crawler%20Obstacle%20Inquiry&body=Hi%20Rugpeak%2C%20I%20am%20interested%20in%20the%209-piece%20RC%20crawler%20steel%20obstacle%20set.%20My%20country%2Fcity%20is%3A%20';
        var small = email.querySelector('small');
        if (small) small.textContent = 'donglin9823@gmail.com';
      }

      if (!buttons.querySelector('.channel-button.whatsapp')) {
        buttons.insertAdjacentHTML('afterbegin', '<a class="channel-button whatsapp" href="https://wa.me/17789571910?text=Hi%20Rugpeak%2C%20I%20am%20interested%20in%20the%209-piece%20RC%20crawler%20steel%20obstacle%20set.%20My%20country%2Fcity%20is%3A%20" target="_blank" rel="noreferrer"><span>WhatsApp</span><small>+1 778-957-1910</small></a>');
      }

      if (!buttons.querySelector('.channel-button.instagram')) {
        var facebook = buttons.querySelector('.channel-button.facebook');
        var instagramHtml = '<a class="channel-button instagram" href="https://www.instagram.com/donglin9823/" target="_blank" rel="noreferrer"><span>Instagram</span><small>@donglin9823</small></a>';
        if (facebook) {
          facebook.insertAdjacentHTML('beforebegin', instagramHtml);
        } else {
          buttons.insertAdjacentHTML('beforeend', instagramHtml);
        }
      }
    });
  }

  function runFixes() {
    replaceText(document.body);
    fixModulePrice();
    injectColorStyles();
    addColorSection();
    fixContactChannels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }
})();
